<!-- <input #input autocomplete="off" [disabled]="disabled" [textMask]="{mask: maskConfig ? maskConfig.mask : false }"
  [(ngModel)]="value" type="{{type}}"> -->

<input
  #input
  autocomplete="off"
  [maskito]="{ mask: maskConfig ? maskConfig.mask : [] }"
  [disabled]="disabled"
  [(ngModel)]="value"
  type="{{ type }}"
/>
